export default "/Frontend/dist/event-background3.c976a1d90fb2a5ac79908f6c508e8c29.svg";